import { render, staticRenderFns } from "./LayersHeaderListPreview.vue?vue&type=template&id=c2f224d6"
import script from "./LayersHeaderListPreview.vue?vue&type=script&lang=ts&setup=true"
export * from "./LayersHeaderListPreview.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports